import { useMemo } from 'react';
import { REVIEW_ANNOTATION_TYPE, TASK_CLASSIFICATION_ID } from '../review-mode-side-panel/constants';
import type { ReviewAnnotationT, ReviewClassificationT } from '../review-mode-side-panel/types';
import type { TaskLevelQuestionAnswersT } from '../types/types';
export { TASK_CLASSIFICATION_ID };
const buildClassificationAttributes = (answers: TaskLevelQuestionAnswersT): ReviewClassificationT[] => Object.values(answers).map(entry => entry ? {
  question: entry.question,
  answers: entry.answers ?? []
} : null).filter((attr): attr is ReviewClassificationT => attr !== null);
type UseTaskClassificationAnnotationProps = {
  taskLevelQuestionAnswers: TaskLevelQuestionAnswersT | undefined;
};
export const useTaskClassificationAnnotation = ({
  taskLevelQuestionAnswers
}: UseTaskClassificationAnnotationProps): ReviewAnnotationT | null => useMemo(() => {
  if (!taskLevelQuestionAnswers || Object.keys(taskLevelQuestionAnswers).length === 0) {
    return null;
  }
  const classificationAttributes = buildClassificationAttributes(taskLevelQuestionAnswers);
  if (classificationAttributes.length === 0) return null;
  return {
    type: REVIEW_ANNOTATION_TYPE.CLASSIFICATION,
    name: 'Task Classification',
    label: 'Task Classification',
    attributes: [{
      classificationAttributes
    }]
  };
}, [taskLevelQuestionAnswers]);